import type { EmvConfigurationDto } from "../../types/EmvConfigurationDto";
import type { EmvConfigurationEntity } from "../../types/EmvConfigurationEntity";

export const EmvConfigurationEntityToDto = ({ ...rest }: Readonly<EmvConfigurationEntity>): EmvConfigurationDto => {
    return { ...rest };
};
